(function () {
  const bar = document.getElementById('StickyATC');
  if (!bar) return;

  const btn = document.getElementById('StickyATCBtn');
  const close = bar.querySelector('.qnkmia-sticky-atc__close');

  // Botón real "Add to cart" del formulario principal
  const mainATC =
    document.querySelector('.product-form__submit') ||
    document.querySelector('button[name="add"]') ||
    document.querySelector('form[action*="/cart/add"] button[type="submit"]');

  // Form principal del producto
  const form =
    document.querySelector('form[action*="/cart/add"]') ||
    document.querySelector('product-form form');

  if (!mainATC || !form) return;

  // Mostrar barra cuando el botón principal no esté visible
  const io = new IntersectionObserver((entries) => {
    const entry = entries[0];
    const visible = entry.isIntersecting;
    bar.classList.toggle('is-visible', !visible);
    bar.setAttribute('aria-hidden', visible ? 'true' : 'false');
  }, { threshold: 0.25 });

  io.observe(mainATC);

  // Cerrar (persistente por sesión)
  const KEY = 'qnkmiaStickyATCClosed';
  if (sessionStorage.getItem(KEY) === '1') {
    bar.classList.remove('is-visible');
    bar.setAttribute('aria-hidden', 'true');
    io.disconnect();
    return;
  }

  close.addEventListener('click', () => {
    sessionStorage.setItem(KEY, '1');
    bar.classList.remove('is-visible');
    bar.setAttribute('aria-hidden', 'true');
    io.disconnect();
  });

  // Al clicar en la barra, enviamos el form real (con la variante seleccionada)
  btn.addEventListener('click', () => {
    // Si el tema deshabilita el submit por variante no seleccionada, respetamos eso
    if (mainATC.hasAttribute('disabled')) {
      // Scroll al formulario para que el usuario seleccione variante
      mainATC.scrollIntoView({ behavior: 'smooth', block: 'center' });
      return;
    }

    // Dispara el click real para mantener toda la lógica del tema/apps
    mainATC.click();
  });
})();
